import script from "./NoPermission.vue?vue&type=script&setup=true&lang=js"
export * from "./NoPermission.vue?vue&type=script&setup=true&lang=js"

import "./NoPermission.vue?vue&type=style&index=0&id=4740e91c&lang=css"

const __exports__ = script;

export default __exports__